/**
 * 倒计时
 */
define(function(require, exports, module) {
    var Base = require('c-base');

    let Timer = Base.extend({
        defaults: {
            // 剩余时间,单位s
            remainTime: 0,
            // 是否需要补齐两位,如8s -> 08(s)
            isDoubleBit: true,
            // 倒计时容器
            wrap: '#J-Countdown',
            // 倒计时容器
            selector: {
                day: '[node-id=day]',
                hour: '[node-id=hour]',
                minute: '[node-id=minute]',
                second: '[node-id=second]'
            }
        },

        initialize: function() {
            let self = this;
            self.Parent.apply(self, arguments);

        },
        // 开始倒计时
        start: function(time) {
            clearTimeout(this.countDown);
           
            if (time <= 0) {
                return;
            } 
            this.set('remainTime', time);
            this.startCountDown();
        },

        /**
         * 分割剩余时间，天、时、分、秒
         * @param time {number} 时间,单位s
         * @return result {object}
         *      @key day {string|number} 天
         *      @key hour {string|number} 时
         *      @key minute {string|number} 分
         *      @key second {string|number} 秒
         */
        splitTime: function(time) {

            var self = this,
                day = Math.floor(time / 86400),
                hour = Math.floor(time % 86400 / 3600),
                minute = Math.floor(time % 86400 % 3600 / 60),
                second = Math.floor(time % 86400 % 3600 % 60);

            return {
                day: day >= 0 ? day : 0,
                hour: hour >= 0 ? hour : 0,
                minute: minute >= 0 ? minute : 0,
                second: second >= 0 ? second : 0
            }

        },

        /**
         * 合并剩余时间到秒
         * @param time {object} 时间
         *      @key day {string|number} 天
         *      @key hour {string|number} 时
         *      @key minute {string|number} 分
         *      @key second {string|number} 秒
         * @return result {number} 
         
         */
        combineTime: function(time) {
            return time.day * 86400 + time.hour * 3600 + time.minute * 60 + time.second;
        },

        /**
         * 格式化时间(补齐两位)
         * @param time {object} 未补齐两位的时间对象
         *      @key day {string|number} 天
         *      @key hour {string|number} 时
         *      @key minute {string|number} 分
         *      @key second {string|number} 秒
         * @return time
         */
        formatTime: function(time) {
            var self = this;
            for (var i in time) {
                time[i] = self.addBit(time[i]);
            }
            return time;
        },

        /**
         * 渲染剩余时间到dom
         * @param result {object} 时间对象
         *      @key day {string|number} 天
         *      @key hour {string|number} 时
         *      @key minute {string|number} 分
         *      @key second {string|number} 秒
         * @return void
         */
        render: function(result) {
            var self = this;
            var nodeWrap = $(this.get('wrap'));
            var selector = this.get('selector');
            
            if (nodeWrap.length > 0) {
                let dayWrap = $(selector.day, nodeWrap);
                let hourWrap = $(selector.hour, nodeWrap);
                let minuteWrap = $(selector.minute, nodeWrap);
                let secondWrap = $(selector.second, nodeWrap);

                if (dayWrap.length > 0) {
                    dayWrap.html(result.day);
                }

                if (hourWrap.length > 0) {
                    hourWrap.html(result.hour);
                }

                if (minuteWrap.length > 0) {
                    minuteWrap.html(result.minute);
                }

                if (secondWrap.length > 0) {
                    secondWrap.html(result.second);
                }
            }
        },

        /**
         * 增加位数
         * @param num {number} 数字
         * @return result {string}
         */
        addBit: function(num) {
            return num < 10 ? '0' + num : num;
        },

        /**
         * 开始倒计时
         * @param void
         * @param {Boolean} flag 内部参数，用来判断是否正在跳动
         * @return void
         */
        startCountDown: function(flag) {
            var self = this,
                localTimeStamp = new Date().getTime(),
                isDoubleBit = self.get('isDoubleBit'),
                localTimeGap,
                now,
                realRemainTime,
                splitTime,
                renderData,
                isEnd;

            self.countDown && clearTimeout(self.countDown);
            self.countDown = setTimeout(function() {
                localTimeGap = new Date().getTime() - localTimeStamp;
                realRemainTime = self.get('remainTime') - localTimeGap / 1000;

                // 设置真正的剩余时间
                self.set('remainTime', realRemainTime);

                splitTime = self.splitTime(realRemainTime);

                renderData = isDoubleBit ? self.formatTime(splitTime) : splitTime;

                self.render(renderData);

                self.emit('tick', {
                    remainTime: realRemainTime,
                    serverTime: new Date().getTime() / 1000
                });

                isEnd = self.isEnd(splitTime);

                self.set('isEnd', isEnd);

                if (isEnd) {
                    self.emit('end');
                    return;
                }

                // 重新呼叫此方法启动演示器
                self.startCountDown(true);
            }, flag ? 1000 : 0);
        },

        /**
         * 判断当前倒计时是否结束
         * @param realTime {object} 参考render参数
         * @return boolean
         */
        isEnd: function(realTime) {
            return realTime.second <= 0 && realTime.minute == 0 && realTime.hour == 0 && realTime.day == 0
        },


        destroy: function() {
            clearTimeout(this.countDown);
        }
    });

    UpAct.countdown = new Timer();

});



// WEBPACK FOOTER //
// ./js/lib/timer/index.js